import styled from "styled-components";
import { borderRadius, spacing, typographyMixin } from "@magicbi/ui-library";

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  background-color: ${({ theme }) => theme.colors.background.secondary};
  border: 1px solid ${({ theme }) => theme.colors.border.stroke};
  border-radius: ${borderRadius.lg};
  overflow: hidden;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing[3]};
  padding: ${spacing[1.5]} ${spacing[3]};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.stroke};
`;

export const Label = styled.span`
  ${typographyMixin("caption", 2)}
  color: ${({ theme }) => theme.colors.text.secondary};
  overflow-wrap: anywhere;
`;

export const CopyButton = styled.button`
  margin-left: auto;
  padding: ${spacing[0.5]} ${spacing[2]};
  ${typographyMixin("caption", 2)}
  color: ${({ theme }) => theme.colors.text.interactive};
  background: transparent;
  border: 1px solid ${({ theme }) => theme.colors.border.stroke};
  border-radius: ${borderRadius.md};
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.surface.secondary};
  }
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.text.interactive};
    outline-offset: 2px;
  }
  &:disabled {
    color: ${({ theme }) => theme.colors.text.disabled};
    background: transparent;
    cursor: not-allowed;
  }
`;

export const Pre = styled.pre<{ $wrap: boolean; $maxHeight?: string }>`
  margin: 0;
  padding: ${spacing[4]};
  ${typographyMixin("caption", 3)}
  color: ${({ theme }) => theme.colors.text.primary};
  font-family: "Courier New", Courier, monospace;
  line-height: 1.6;
  white-space: ${({ $wrap }) => ($wrap ? "pre-wrap" : "pre")};
  /* Long URLs still break, but words stay whole. */
  overflow-wrap: ${({ $wrap }) => ($wrap ? "anywhere" : "normal")};
  overflow: auto;
  ${({ $maxHeight }) => ($maxHeight ? `max-height: ${$maxHeight};` : "")}
`;
